export const standardSquawkStatuses = [
  {
    label: "Unverified",
    value: "Unverified",
    grounding: false,
  },
];
